import { BASE_URL } from './inquiries';
import { fetchWithAuth } from './apiClient';

export const getProducts = async () => {
    const response = await fetch(`${BASE_URL}/api/products`);
    if (!response.ok) throw new Error('Failed to fetch products');
    return response.json();
};

export const getProduct = async (id) => {
    const response = await fetch(`${BASE_URL}/api/products/${id}`);
    if (!response.ok) throw new Error('Failed to fetch product');
    return response.json();
};

export const createProduct = async (data) => {
    const response = await fetchWithAuth(`${BASE_URL}/api/products`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Failed to create product');
    return response.json();
};

export const updateProduct = async (id, data) => {
    const response = await fetchWithAuth(`${BASE_URL}/api/products/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Failed to update product');
    return response.json();
};

export const deleteProduct = async (id) => {
    const response = await fetchWithAuth(`${BASE_URL}/api/products/${id}`, {
        method: 'DELETE'
    });
    if (!response.ok) throw new Error('Failed to delete product');
    return true; // Return success status
};

// Category API
export const getProductCategories = async () => {
    const response = await fetch(`${BASE_URL}/api/products/categories`);
    if (!response.ok) throw new Error('Failed to fetch product categories');
    return response.json();
};

export const createProductCategory = async (data) => {
    const response = await fetchWithAuth(`${BASE_URL}/api/products/categories`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Failed to create product category');
    return response.json();
};

export const updateProductCategory = async (id, data) => {
    const response = await fetchWithAuth(`${BASE_URL}/api/products/categories/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Failed to update product category');
    return response.json();
};

export const deleteProductCategory = async (id) => {
    const response = await fetchWithAuth(`${BASE_URL}/api/products/categories/${id}`, {
        method: 'DELETE'
    });
    if (!response.ok) throw new Error('Failed to delete product category');
    return true;
};

export const reorderProducts = async (ids) => {
    const response = await fetchWithAuth(`${BASE_URL}/api/products/reorder`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ids })
    });
    if (!response.ok) throw new Error('Failed to reorder products');
    return response.json();
};
